<template>
  <div class="gallery-cell">
    <div class="uk-grid-small" uk-grid v-if="hasAttachments">
      <div class="uk-width-small" v-for="attachment in attachments">
        <thumbnail :attachment="attachment" />
      </div>
    </div>
    <text-placeholder v-else />
  </div>
</template>

<script>
import TextPlaceholder from '@/components/TextPlaceholder';
import Thumbnail from '@/components/Thumbnail';

export default {
  name: 'mini-gallery',
  components: {
    TextPlaceholder,
    Thumbnail,
  },
  props: {
    attachments: {
      type: Array,
      default: () => [],
      required: true,
    },
  },
  computed: {
    hasAttachments() {
      return this.attachments && this.attachments.length > 0;
    },
  },
};
</script>



// WEBPACK FOOTER //
// GalleryCell.vue?ad5df36e